import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sandbox',
    templateUrl: './sandbox.component.html',
    styleUrls: ['./sandbox.component.css'],
    standalone: false
})
export class SandboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
